// Requires URL to begin with https
const URL_REGEX_EXPRESSION = /https:(?:\/)+[^\s]+/g

export type TextOrLink = {
  type: 'text' | 'link'
  value: string
}

export default function linkifyText(text: string): TextOrLink[] {
  const urlRegex = new RegExp(URL_REGEX_EXPRESSION)

  const splitText: TextOrLink[] = []

  let startIndex = 0
  let match = urlRegex.exec(text)

  while (match != null) {
    if (match.index > startIndex) {
      splitText.push({
        type: 'text',
        value: text.substr(startIndex, match.index - startIndex),
      })
    }

    let linkText = text.substr(match.index, match[0].length)

    // Removes trailing dots and closing parentheses etc
    while (linkText.endsWith('.') || linkText.endsWith(')') || linkText.endsWith('?')) {
      linkText = linkText.slice(0, -1)
      match[0] = match[0].slice(0, -1)
    }

    splitText.push({
      type: 'link',
      value: linkText,
    })

    startIndex = match.index + match[0].length
    match = urlRegex.exec(text)
  }

  if (startIndex < text.length) {
    splitText.push({
      type: 'text',
      value: text.substr(startIndex),
    })
  }

  return splitText
}
